// eslint-disable-next-line
export default new (class DocumentModel {
  // static API_URL = process.env.REACT_APP_API_URL;

  async get(data) {
    const model = {};

    model.id = data.id || 0;
    model.section = data.section || "";
    model.order = data.order || 0;
    model.name = data.documentType || [];
    model.document = data.document || [];

    return model;
  }
})();
